import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';

import RichTextDisplay from '../../components/RichTextDisplay';
import FileUploadItem from '../../../client/components/FileUploadItem';

import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';

class FileUploadSlide extends Component {
    static propTypes = {
        filesById: PropTypes.object,
        content: PropTypes.shape({
            description: PropTypes.string,
            numberOfFiles: PropTypes.number,
            fileOptions: PropTypes.arrayOf(
                PropTypes.shape({
                    fileTitle: PropTypes.string,
                    fileDescription: PropTypes.string
                })
            )
        }),
        completedData: PropTypes.object,
        canMoveToNext: PropTypes.func,
        nextSectionName: PropTypes.string,
        currentUser: PropTypes.object,
        name: PropTypes.string,
        isRequired: PropTypes.bool,
        handleFileChange: PropTypes.func,
        parentId: PropTypes.string,
        parentType: PropTypes.string,
        onChange: PropTypes.func,
        sendWorkspaceSegementEvent: PropTypes.func
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const { onChange, canMoveToNext, completedData = {}, content, isRequired = false } = this.props;

        const data = get(completedData, 'data', {}) || {};
        const fileCount = Object.keys(data).length;
        const isAnswered = fileCount === content.numberOfFiles;

        onChange(completedData.data, true, isAnswered);
        canMoveToNext((isRequired && isAnswered) || !isRequired);
    }

    /**
     *
     * @param {number} index
     * @param {Object} fileInfo
     * @return {Promise.<TResult>}
     * @private
     */
    _onFileUpload = (index, fileInfo) => {
        const { completedData, content, isRequired = false, canMoveToNext } = this.props;

        return this.props.handleFileChange(fileInfo).then((fileResult) => {
            if (isEmpty(completedData.data)) {
                completedData.data = {};
            }
            completedData.data[index] = { fileId: fileResult._id };

            const fileCount = Object.keys(completedData.data).length;
            const isAnswered = fileCount >= content.numberOfFiles;

            canMoveToNext((isRequired && isAnswered) || !isRequired);
            this.props.onChange(completedData.data, completedData.isCompleted, isAnswered);
        });
    };

    render() {
        const {
            currentUser,
            filesById,
            name,
            nextSectionName,
            content: { description = '', fileOptions = [] },
            parentId,
            parentType,
            completedData,
            sendWorkspaceSegementEvent
        } = this.props;

        let fileUploadSection = null;
        if (fileOptions.length > 0) {
            fileUploadSection = fileOptions.map((fileOption, index) => {
                const fileId = get(completedData, `data[${index}].fileId`, '');
                const fileObject = get(filesById, `[${fileId}]`, {});

                return (
                    <FileUploadItem
                        key={index}
                        uploadedFile={fileObject}
                        parentId={parentId}
                        parentType={parentType}
                        title={fileOption.fileTitle}
                        description={fileOption.fileDescription}
                        onFileUpload={this._onFileUpload.bind(this, index)}
                    />
                );
            });
        }

        return (
            <div className={'fileUploadSlide'}>
                <h1 className={'verb-title-1 playerHeader'}>{name}</h1>
                <div className={'playerContent'}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />

                    {fileUploadSection}
                </div>
            </div>
        );
    }
}

export const FileUploadSlideComponent = FileUploadSlide;
export default TrackPlayerSlideComponent(FileUploadSlide);
